import { DatePicker, Form, Input, Select } from 'antd';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { API_DATE_FS } from './shared';

const PROFESSIONAL_REGISTRATIONS_BODIES = [
  'Australian Association of Social Workers',
  'Australian Counselling Association',
  'Accreditation as a Mental Health Social Worker',
  'Association of Massage Therapists',
  'Australian Music Therapy Association',
  'Australian Natural Therapists Association',
  'Australian, New Zealand and Asian Creative Arts Therapies Association',
  'Australian Society of Rehabilitation Counsellors - Full Membership',
  'Australian Society of Rehabilitation Counsellors - Associate Membership',
  'Australian Society of Rehabilitation Counsellors - Affiliate Membership',
  'Australian Traditional Medicine Society',
  'Career Development Association of Australia',
  'Certified Practicing Accountant',
  'Dietitians Australia',
  'Exercise and Sports Science Association - must be Accredited Exercise Physiologist (AEP)',
  'Massage Association of Australia',
  'Massage and Myotherapy Association',
  'Psychotherapy and Counselling Federation of Australia',
  'Rehabilitation Counselling Association of Australia',
  'Speech Pathology Australia',
];

export class ProfRegFormItems extends PureComponent {
  static slug = 'profreg';

  constructor(props) {
    super(props);
    this.state = { };
  }

  static getSubmissionData(checkData, constituent) {
    return {
      identifier: checkData.identifier,
      issued_by: checkData.issued_by,
      ...checkData.expiry && { expiry: checkData.expiry.format(API_DATE_FS) },
      fullName: constituent.get('fullName'),
    };
  }

  disablePastDate = current => current && current < moment().endOf('day');

  render() {
    const { form, disabled, rules } = this.props;
    const { getFieldDecorator } = form;
    const { slug } = this.constructor;

    const ident = {
      label: 'Identifier',
      slug: `${slug}.identifier`,
    };
    const issuedBy = {
      label: 'Membership Body',
      slug: `${slug}.issued_by`,
    };
    const expiry = {
      label: 'Expiry',
      slug: `${slug}.expiry`,
    };

    return (<>
      <Form.Item label={ issuedBy.label }>
        { getFieldDecorator(issuedBy.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${issuedBy.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Select
            showSearch
            disabled={disabled}
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children
              .toString()
              .toLowerCase()
              .includes(input.toLowerCase())
            }
          >
            {
            PROFESSIONAL_REGISTRATIONS_BODIES.map(member => (
              <Select.Option key={member} value={member}>
                {member}
              </Select.Option>
            ))}
          </Select>,
        )
        }
      </Form.Item>
      <Form.Item label={ ident.label }>
        { getFieldDecorator(ident.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${ident.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Input
            disabled={ disabled }
          />,
        )
        }
      </Form.Item>
      <Form.Item label={ expiry.label }>
        {getFieldDecorator(expiry.slug, {
          rules: [...(rules || [])],
        })(
          <DatePicker
            disabled={disabled}
            disabledDate={this.disablePastDate}
          />,
        )}
      </Form.Item>

    </>);
  }
}
